import React from 'react';
import './NavigationLink.less';

export const NavigationLink = ({text, isPrimary}) => {
	return <span className={`navigation-link ${
		isPrimary ? 'navigation-link--primary' : ''
	}`}>{text}</span>;
};
